module.exports = __webpack_public_path__ + "statics/img/cate8-4@2x.06d89d78.png";